var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.88889V3.55556H3.55556V8.88889H32ZM32 12.4444H3.55556V28.4444H32V12.4444ZM1.77778 0H33.7778C34.2493 0 34.7015 0.187301 35.0349 0.520699C35.3683 0.854097 35.5556 1.30628 35.5556 1.77778V30.2222C35.5556 30.6937 35.3683 31.1459 35.0349 31.4793C34.7015 31.8127 34.2493 32 33.7778 32H1.77778C1.30628 32 0.854097 31.8127 0.520699 31.4793C0.187301 31.1459 0 30.6937 0 30.2222V1.77778C0 1.30628 0.187301 0.854097 0.520699 0.520699C0.854097 0.187301 1.30628 0 1.77778 0ZM16 19.5556H26.6667V23.1111H8L16 15.1111V19.5556Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundRequests);
export default __webpack_public_path__ + "static/media/refund-requests.6780650087f6c2d8f6a90249743d5117.svg";
export { ForwardRef as ReactComponent };